import type { Store } from '../../types/services/auth';

export const normalizeStoresForDropdown = (stores: Store[]) => {
  const storesById = new Map<string, Store>();

  stores.forEach((store) => {
    if (store?.id) {
      storesById.set(store.id, store);
    }
  });

  return Array.from(storesById.values()).sort((a, b) => {
    const aName = (a.name || '').trim();
    const bName = (b.name || '').trim();

    return aName.localeCompare(bName, undefined, { sensitivity: 'base' })
      || (a.address_line1 || '').localeCompare(b.address_line1 || '', undefined, { sensitivity: 'base' });
  });
};
